import React, { useState, useEffect } from 'react'
import classes from './LoginPage2.module.css'
import { v4 as uuidv4 } from 'uuid'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { loginApi } from '../../http/http'
import { useDispatch, useSelector } from 'react-redux'
import { setUserDetails } from '../../store/slices/userSlice'
import { toast } from 'react-toastify'
import SmallLoader from '../../component/SmallLoader'
import { useTranslation } from 'react-i18next'

const LoginPage2 = () => {

    const [msisdn, setMsisdn] = useState("")
    const [loginLoading, setLoginLoading] = useState(false)
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [extRef, setExtRef] = useState(null)
    const dispatch = useDispatch()

    const {t}=useTranslation();

    const { userDetails } = useSelector(state => state?.persisted?.userSlice)

    useEffect(() => {
        if (userDetails?.token) navigate("/home")
    }, [userDetails])

    useEffect(() => {
        if (searchParams.get("ext_ref")) {
            setExtRef(searchParams.get("ext_ref"))
        } else {
            setSearchParams({ ext_ref: uuidv4() })
        }
    }, [searchParams])

    const handleFormSubmission = async (e) => {
        try {
            e.preventDefault()
            if (msisdn?.trim().length === 0) return
            setLoginLoading(true)
            const response = await loginApi(msisdn)
            dispatch(setUserDetails(response?.data))
            setLoginLoading(false)
            toast.success(t("20"))
            navigate("/home")
        } catch (error) {
            setLoginLoading(false)
            toast.error(
                error?.response?.data?.message ||
                error?.response?.message ||
                error?.data?.message ||
                t("2")
            )
        }
    }

    return (
        <div className={classes.page}>

            {/* ══ LEFT — Brand Hero ══ */}
            <div className={classes.leftPanel}>
                <div className={classes.leftGrid} />
                <div className={classes.glowOrb} />
                <div className={classes.glowOrb2} />
                <div className={classes.vodaStrip} />

                {/* Logo */}
                    <div className={classes.logo}>
          <div>
            <div className={classes.logoWordmark}>
            <img src="/assets/images/logo.png" alt="football" className={classes.logo_img} />

            </div>
            <div className={classes.logoPowered}>{t("3")} Door2Future Consultants Pvt Ltd</div>
          </div>
        </div>

                <p className={classes.heroEyebrow}>{t("52")}</p>
                <h1 className={classes.heroTitle}>
                    {t("53")}
                    <span className={classes.accent}>{t("54")}</span>
                </h1>
                <p className={classes.heroSub}>
                    {t("55")}
                </p>

                <div className={classes.pillsRow}>
                   <span className={classes.pill}>{t("56")}</span>
                           <span className={classes.pill}>{t("57")}</span>
                           <span className={classes.pill}>{t("58")}</span>
                           <span className={classes.pill}>{t("59")}</span>
                </div>

            </div>

            {/* ══ RIGHT — Form ══ */}
            <div className={classes.rightPanel}>
                <div className={classes.rightGrid} />
                <div className={classes.formContainer}>

                    <h2 className={classes.formTitle}>
                        {t("60")} <span>{t("61")}</span>
                    </h2>
                    <p className={classes.formSubtitle}>
                        {t("62")}
                    </p>

                    {/* Tab toggle */}
                    <div className={classes.tabToggle}>
                        <button type="button" className={`${classes.tab} ${classes.activeTab}`}>
                            {t("33")}
                        </button>
                        <button
                            type="button"
                            className={classes.tab}
                            onClick={() => navigate(`/subscribe?ext_ref=${extRef}`)}
                        >
                            {t("34")}
                        </button>
                    </div>

                    <form onSubmit={handleFormSubmission}>

                        {/* Phone */}
                        <p className={classes.sectionLabel}>{t("63")}</p>
                        <div className={classes.phoneRow}>
                            <div className={classes.countryPill}>
                                <img src="/assets/images/flag.png" alt="Tanzania" className={classes.flag} />
                                <span className={classes.dialCode}>+255</span>
                            </div>
                            <input
                                id="msisdn"
                                name="msisdn"
                                type="number"
                                autoFocus
                                onWheel={(e) => e.target.blur()}
                                placeholder={t("64")}
                                className={classes.phoneInput}
                                onChange={(e) => setMsisdn(e.target.value)}
                                value={msisdn}
                            />
                        </div>

                        {/* Terms */}
                        <div className={classes.termsRow}>
                            <input
                                type="checkbox"
                                id="terms"
                                className={classes.termsCheck}
                                checked
                                readOnly
                            />
                            <label htmlFor="terms" className={classes.termsText}>
                               {t("65")}{" "}
                                <span className={classes.termsLink}>{t("66")} &amp; {t("67")}</span>
                            </label>
                        </div>

                        {/* CTA */}
                        <button type="submit" disabled={loginLoading} className={classes.ctaBtn}>
                            {loginLoading
                                ? <SmallLoader style={{ border: "4px solid #ffffff" }} />
                                : <>{t("68")}</>
                            }
                        </button>

                    </form>

                    {/* Switch prompt */}
                    <p className={classes.switchPrompt}>
                        {t("69")}{" "}
                        <span
                            className={classes.switchLink}
                            onClick={() => navigate(`/subscribe?ext_ref=${extRef}`)}
                        >
                            {t("70")}
                        </span>
                    </p>

                    {/* Copyright */}
                    <div className={classes.copyrightFooter}>
                        <div className={classes.copyrightDivider} />
                        <div className={classes.copyrightInner}>
                            <span className={classes.copyrightBadge}>
                                <span className={classes.copyrightBadgeIcon}>⚽</span>
                                Vodacom Live Football Game
                            </span>
                            <p className={classes.copyrightText}>
                                © {new Date().getFullYear()} Door2Future Consultants Pvt Ltd
                            </p>
                            <p className={classes.copyrightSub}>All rights reserved</p>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )
}

export default LoginPage2